<template>
    <div class="widget collateral-build-publish-widget">
        <div class="widget-header">
            <h3>Publish to Partners</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <p>Please select which partners you would like this collateral build to be published to:</p>
            <client-published-collateral-build-table
                :collateralBuildId="collateralBuildId"
                @update:selectedItems="updateSelectedClients($event)" />
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" @click="closeWidget">Cancel</app-button>
            </div>
            <div class="action-container">
                <app-button @click="save" :loading="isSaving">
                    {{ isSaving ? 'Saving' : 'Save' }}
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const ClientPublishedCollateralBuildTable = () => import('@/components/client/client-published-collateral-build-table');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'collateral-build-publish-widget',

    props: ['options', 'widget'],

    components: {
        'app-button': AppButton,
        'client-published-collateral-build-table': ClientPublishedCollateralBuildTable,
        'widget-close-svg': WidgetCloseSvg,
        'loading-screen-svg': LoadingScreenSvg
    },

    data() {
        return {
            isInitializing: true,
            isSaving: false,
            collateralBuildId: this.options.collateralBuildId,
            agencyId: null,
            selectedClients: []
        }
    },

    computed: {
        
    },

    methods: {
        updateSelectedClients(selectedClients) {
            this.selectedClients = selectedClients;
        },

        save() {  
            this.isSaving = true;
            var clientIds = this.selectedClients.map(client => client.id );

            this.$api
                .post(`/api/CollateralBuilds/${ this.collateralBuildId }/Publish`, clientIds)
                .then(() => {
                    this.$helpers.showSuccessNotification('Your publish settings have been updated.');
                    this.isSaving = false;
                    
                    EventBus.$emit('collateral-build:update');
                    this.closeWidget();
                })
                .catch(error => {
                    this.$helpers.showFailNotification('An error occurred while saving your publish settings.', { error });
                    this.isSaving = false;
                });          
        },

        getCollateralBuild() {
            this.$api
                .get(`/service/CollateralBuilds/?$filter=Id eq ${ this.collateralBuildId }`)
                .then(response => {
                    this.agencyId = response.data.value[0].AgencyId;                    
                    this.isInitializing = false;
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('An error occurred while getting your collateral build settings.', { error });
                    this.closeWidget();
                    this.isInitializing = false;
                }); 
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        }
    },

    created() {
        this.getCollateralBuild();
    }
}
</script>

<style>
.collateral-build-publish-widget .saving-step {
    text-align: center;
}

.collateral-build-publish-widget .content-wrapper {
    padding: 20px;
}

.collateral-build-publish-widget .action-container {
    display: flex;
}

.collateral-build-publish-widget .action-container .btn {
    margin-left: 15px;
}

.collateral-build-publish-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877D88;
}

.collateral-build-publish-widget .cancel-container .btn.transparent-btn:hover {
    background: #E1E0E5;
}

.collateral-build-publish-widget .action-container .btn.white-btn {
    background: #FFFFFF;
    color: #877D88;
    border: 2px solid #E9E9EF;
}
</style>
